import React, { useState } from "react";
import { ListMusic, Music2 } from "lucide-react";
import { Input } from "./ui/input";

export default function TrackDrawer({ tracks, onLoadDeck, deckA, deckB }) {
  const [q, setQ] = useState("");
  const filtered = q
    ? tracks.filter(
        (t) =>
          (t.title || "").toLowerCase().includes(q.toLowerCase()) ||
          (t.channel || "").toLowerCase().includes(q.toLowerCase())
      )
    : tracks;

  return (
    <div className="rounded-2xl bg-zinc-950/70 border border-zinc-800 overflow-hidden">
      <div className="px-4 py-3 border-b border-zinc-800 flex items-center gap-3">
        <ListMusic className="w-4 h-4 text-zinc-500" />
        <span className="font-mono text-[10px] tracking-widest text-zinc-500">QUEUE</span>
        <span className="font-mono text-[10px] text-zinc-600">·</span>
        <span className="font-mono text-[10px] text-zinc-500">{tracks.length} TRACKS</span>
        <div className="flex-1" />
        <Input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Filter queue..."
          className="max-w-[200px] h-8 text-xs bg-zinc-900 border-zinc-800"
          data-testid="dj-queue-filter"
        />
      </div>
      {tracks.length === 0 ? (
        <div className="p-8 text-center text-zinc-500 text-sm">
          <Music2 className="w-6 h-6 mx-auto mb-2 opacity-40" />
          Playlist is empty. Head to the <b className="text-white">Playlist</b> tab to add tracks.
        </div>
      ) : (
        <div className="max-h-64 overflow-y-auto divide-y divide-zinc-800/60">
          {filtered.map((s, i) => {
            const loadedA = deckA?.video_id === s.video_id;
            const loadedB = deckB?.video_id === s.video_id;
            return (
              <div
                key={s.song_uid}
                className="flex items-center gap-3 px-3 py-2 hover:bg-zinc-900/40"
              >
                <span className="font-mono text-[10px] text-zinc-600 w-5 text-right">{i + 1}</span>
                <img src={s.thumbnail} alt="" className="w-10 h-8 object-cover rounded" />
                <div className="flex-1 min-w-0">
                  <div className="text-xs text-white truncate leading-tight flex items-center gap-2">
                    {loadedA && (
                      <span className="px-1 py-0.5 rounded text-[8px] font-mono tracking-widest" style={{ background: "#d946ef22", color: "#d946ef" }}>A</span>
                    )}
                    {loadedB && (
                      <span className="px-1 py-0.5 rounded text-[8px] font-mono tracking-widest" style={{ background: "#06b6d422", color: "#06b6d4" }}>B</span>
                    )}
                    <span className="truncate">{s.title}</span>
                  </div>
                  <div className="text-[10px] text-zinc-500 truncate">{s.channel} · {s.bpm}{s.bpm_manual ? "" : "~"} BPM</div>
                </div>
                <div className="flex items-center gap-1 shrink-0">
                  <button
                    onClick={() => onLoadDeck("A", s)}
                    className="px-2 py-1 rounded text-[10px] font-mono font-bold tracking-widest border"
                    style={{
                      color: "#d946ef",
                      borderColor: loadedA ? "#d946ef" : "#d946ef55",
                      background: loadedA ? "rgba(217,70,239,0.18)" : "rgba(217,70,239,0.06)",
                    }}
                    data-testid={`dj-load-a-${s.song_uid}`}
                  >
                    A
                  </button>
                  <button
                    onClick={() => onLoadDeck("B", s)}
                    className="px-2 py-1 rounded text-[10px] font-mono font-bold tracking-widest border"
                    style={{
                      color: "#06b6d4",
                      borderColor: loadedB ? "#06b6d4" : "#06b6d455",
                      background: loadedB ? "rgba(6,182,212,0.18)" : "rgba(6,182,212,0.06)",
                    }}
                    data-testid={`dj-load-b-${s.song_uid}`}
                  >
                    B
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
